import { useEffect, useState } from 'react';

/** Širina, do katere velja postavitev za telefon (zasnova »Pregled – telefon«). */
export const TELEFON_MEDIA = '(max-width: 600px)';

/**
 * Ali je zaslon ozek kot telefon.
 *
 * Kjer ima zasnova za telefon drugačno obliko (seznam namesto kartic), se
 * izriše samo ena oblika; brez `matchMedia` (testi) velja splet.
 */
export function useTelefon(): boolean {
  const poizvedba = (): MediaQueryList | null =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(TELEFON_MEDIA) : null;
  const [telefon, setTelefon] = useState(() => poizvedba()?.matches ?? false);
  useEffect(() => {
    const mq = poizvedba();
    if (mq === null) return;
    const ob = (): void => {
      setTelefon(mq.matches);
    };
    ob();
    mq.addEventListener('change', ob);
    return () => {
      mq.removeEventListener('change', ob);
    };
  }, []);
  return telefon;
}
